import React from 'react';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { LoggedOutProductLibraryContainsItem } from '../../types/library';

type LibraryTopicLinkProps = {
  item: LoggedOutProductLibraryContainsItem;
  href: string;
};

/**
 * A component that renders a link to a library topic.
 * @component
 * @param {LibraryTopicLinkProps} props - The properties for the component.
 * @param {Object} props.item - The item object containing information about the library topic.
 * @param {string} props.item.name - The name of the library topic.
 * @param {string} [props.item.displayName] - The display name of the library topic.
 * @param {string} props.href - The URL to link to.
 * @returns {JSX.Element} The rendered link component.
 */
const LibraryTopicLink = ({ item, href }: LibraryTopicLinkProps) => (
  <a data-testid="library-topic-box-l5-level-link" href={href}>
    <Flex
      className="flex-col ml-8 rounded-lg transition-all hover:text-blue-600 hover:bg-slate-200"
      data-id={item.name}
    >
      <Flex className="flex-col p-2" data-id={item.name}>
        <P data-testid="library-topic-box-l5-level-name">
          {item.displayName || item.name}
        </P>
      </Flex>
    </Flex>
  </a>
);

export default LibraryTopicLink;
